import axios from "axios";

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 40000,
});

// ✅ Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // /mfa 401s mean "this challenge is dead", not "your session ended".
    // The caller has no session yet, so there is nothing to clear and
    // nowhere to redirect — TwoFactorPrompt handles it in place.
    const isMfaCall = error.config?.url?.includes("/mfa/");

    if (error.response?.status === 401 && !isMfaCall) {
      const url = window.location.href ;
      if(!url.includes("onboarding/add"))
      {
        localStorage.removeItem("token");
        const bypassRedirect = Boolean(window.__logoutOnAccessActive);

        if (!bypassRedirect) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function getBaseURL() {
  // console.log("hostname", window.location.hostname);
  // console.log("OVERRIDE_SERVER", process.env.OVERRIDE_SERVER);
  
  const HOSTS = {
    "localhost": "http://localhost:80/v1/",
    // "localhost": "https://backend.salusion-staging.com/v1/",
    "my.salusion.com": "https://backend.salusion.com/v1/",
    "my.salusion-staging.com": "https://backend.salusion-staging.com/v1/",
    "my.salusion-preprod.com": "https://backend.salusion-preprod.com/v1/",
    "my.salusion-production.com": "https://backend.salusion-production.com/v1/"
  };
  // console.log("window.location.hostname", window.location.hostname);
  const hostname = window.location.hostname || "my.salusion-staging.com";
  let baseURL = HOSTS[hostname];
  // console.log("baseURL", baseURL);
  // Handle codespace environment
  // if (process.env.CODESPACE_ACCOUNT?.toUpperCase() === "TRUE") {
  //   baseURL = HOSTS["my.salusion-staging.com"];
  // }

  // Use override server or fallback to production
  return baseURL || process.env.OVERRIDE_SERVER || "https://backend.salusion-staging.com/v1/";
  // return "https://backend.salusion-staging.com/v1/";
}
api.interceptors.request.use((config) => {
  // Add x-env header if override server is being used
  if (process.env.OVERRIDE_SERVER) {
    config.headers["x-env"] = "x-env";
  }
  return config;
});
export default api;
